import dayjs from "dayjs";

/**
 * Converts filter params (from useTableFilters.getQueryParams()) to the shape expected by
 * getUtilityBills / getDuplicateBillsData. Formats dates as YYYY-MM-DD and ensures numeric fields are numbers.
 */
export const filterParamsToQuery = (params: Record<string, unknown>): Record<string, unknown> => {
  if (!params || Object.keys(params).length === 0) return {};

  const dateKeys = [
    "consumptionStartDate",
    "consumptionEndDate",
    "createdDate",
    "updateDate",
  ];
  const numberKeys = [
    "measuredValue",
    "co2Emission",
    "amount",
  ];

  const result: Record<string, unknown> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;

    if (dateKeys.includes(key)) {
      const formatted = value instanceof Date
        ? dayjs(value).format("YYYY-MM-DD")
        : dayjs(String(value)).isValid()
          ? dayjs(String(value)).format("YYYY-MM-DD")
          : undefined;
      if (formatted) result[key] = formatted;
      return;
    }

    if (numberKeys.includes(key)) {
      const num = typeof value === "number" ? value : parseFloat(String(value));
      if (Number.isFinite(num)) result[key] = num;
      return;
    }

    if (key === "scope" && typeof value === "string") {
      result[key] = value.replace(/\s/g, "");
      return;
    }

    result[key] = typeof value === "string" ? value.trim() : value;
  });

  return result;
};
